import { render, staticRenderFns } from "./RootFooter.vue?vue&type=template&id=299e1927&"
import script from "./RootFooter.vue?vue&type=script&lang=js&"
export * from "./RootFooter.vue?vue&type=script&lang=js&"
import style0 from "./RootFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports